var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckEmailSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2568_10824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2219 25.1373C44.3164 23.9379 42.7462 22.2749 41.6581 20.3038C40.5699 18.3326 39.9993 16.1178 39.9997 13.8662H6.96859C6.64956 13.8711 6.33264 13.919 6.02637 14.0084L31.7153 39.5907L46.2219 25.1373Z",
    fill: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3339 27.2004C52.1308 27.1899 50.9348 27.0165 49.7783 26.6848L34.2939 42.1159C33.6277 42.7781 32.7265 43.1498 31.7872 43.1498C30.8479 43.1498 29.9467 42.7781 29.2805 42.1159L3.55609 16.5337C3.47722 16.8235 3.43541 17.1222 3.43164 17.4226V52.9781C3.43164 53.9211 3.80624 54.8255 4.47304 55.4923C5.13983 56.1591 6.0442 56.5337 6.9872 56.5337H56.765C57.708 56.5337 58.6123 56.1591 59.2791 55.4923C59.9459 54.8255 60.3205 53.9211 60.3205 52.9781V25.227C58.2209 26.5227 55.8011 27.2062 53.3339 27.2004ZM9.42275 52.9781H6.95164V50.4359L19.8761 37.6181L22.3827 40.1248L9.42275 52.9781ZM56.7294 52.9781H54.2405L41.2805 40.1248L43.7872 37.6181L56.7116 50.4359L56.7294 52.9781Z",
    fill: "#FFDCA8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.6315 8.78626C62.4753 8.63005 62.222 8.63005 62.0658 8.78626L52.6633 18.1888L47.9329 13.4585C47.7767 13.3023 47.5234 13.3023 47.3672 13.4585L46.2828 14.5429C46.1266 14.6991 46.1266 14.9523 46.2828 15.1085L52.3804 21.2072C52.5366 21.3634 52.7899 21.3635 52.9461 21.2073L63.717 10.4375C63.8732 10.2813 63.8732 10.028 63.717 9.87178L62.6315 8.78626Z",
    fill: "#FFDCA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2568_10824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckEmailSvg);
export default __webpack_public_path__ + "static/media/CheckEmailSVG.14a831ba1cac6198f68bb67b49c1e773.svg";
export { ForwardRef as ReactComponent };